import { Injectable } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { SomethingWentWrongModalComponent } from './something-went-wrong-modal.component';
import { LoaderService } from '../loader/loader.service';

/**
 * Opens the "Something went wrong" modal. Used by InterceptorService for network/5xx
 * failures and by ApiService for its request timeouts. The page is never reloaded from
 * here — only when the user clicks "Reload" in the modal.
 */
@Injectable({
  providedIn: 'root'
})
export class SomethingWentWrongService {
  // Several requests usually fail together; only one modal at a time.
  private isOpen = false;

  constructor(private modalService: BsModalService, private _loader: LoaderService) { }

  show() {
    // Callers show the loader before a request and often only hide it on success, so after
    // a failed call it would spin on forever over the modal. Stop it here, for everyone.
    this._loader.hideLoader();
    if (this.isOpen) {
      return;
    }
    this.isOpen = true;
    const modalRef = this.modalService.show(SomethingWentWrongModalComponent, {
      class: 'modal-dialog-centered',
      // Reload is the only way out, as in the design: no backdrop click, no Esc.
      backdrop: 'static',
      keyboard: false
    });
    modalRef.onHidden?.subscribe(() => {
      this.isOpen = false;
    });
  }
}
